import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "terminal" }
const _hoisted_2 = { class: "output" }
const _hoisted_3 = { class: "prompt" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "$", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.output, (line) => {
        return (_openBlock(), _createElementBlock("div", {
          key: line.id
        }, _toDisplayString(line), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.command) = $event)),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.executeCommand && _ctx.executeCommand(...args)), ["enter"])),
        autofocus: ""
      }, null, 544), [
        [_vModelText, _ctx.command]
      ])
    ])
  ]))
}